import _taggedTemplateLiteral from "/home/vsts/work/1/s/Office.Planner.Website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", " !important;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  & > *:first-child {\n    width: ", ";\n    height: ", ";\n    border-radius: ", ";\n    display: flex;\n    user-select: none;\n  }\n\n  .avatar-initials {\n    color: ", ";\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n\n    ", ";\n  }\n\n  .avatar-label {\n    margin-left: 0.75rem;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .avatar-text {\n    font-size: 0.875rem;\n    color: ", ";\n    font-weight: 500;\n  }\n\n  .avatar-subtext {\n    font-size: 0.8125rem;\n    color: ", ";\n    margin-top: 0.25rem;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import initials from 'initials';
import { getColorFromString } from '../utils/colors';
import AvatarGroup from './AvatarGroup';

var getSize = function getSize(size) {
  var sizes = {
    default: '3rem',
    large: '6rem'
  };
  if (typeof size === 'number') return "".concat(size, "px");
  return sizes[size];
};

var getBorderRadius = function getBorderRadius(size) {
  var sizes = {
    default: '1rem',
    large: '2rem'
  };
  if (typeof size === 'number') return "".concat(size / 4, "px");
  return sizes[size];
};

var StyledAvatar = styled.div(_templateObject(), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.theme.colors.accent1;
}, function (props) {
  return props.isCurrentUser && css(_templateObject2(), function (props) {
    return props.theme.colors.primary;
  });
}, function (props) {
  return props.isCurrentUser ? props.theme.colors.primary : props.theme.colors.foreground;
}, function (props) {
  return props.theme.colors.accent8;
});

function Avatar(_a) {
  var text = _a.text,
      src = _a.src,
      _a$showLabel = _a.showLabel,
      showLabel = _a$showLabel === void 0 ? false : _a$showLabel,
      subText = _a.subText,
      _a$size = _a.size,
      size = _a$size === void 0 ? 'default' : _a$size,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      style = _a.style,
      _a$isCurrentUser = _a.isCurrentUser,
      isCurrentUser = _a$isCurrentUser === void 0 ? false : _a$isCurrentUser,
      rest = __rest(_a, ["text", "src", "showLabel", "subText", "size", "className", "style", "isCurrentUser"]);

  return _jsxs(StyledAvatar, Object.assign({
    className: "avatar ".concat(className),
    size: getSize(size),
    borderRadius: getBorderRadius(size),
    isCurrentUser: isCurrentUser,
    style: style
  }, rest, {
    children: [src ? _jsx("img", {
      className: "avatar-img",
      src: src,
      alt: text
    }, void 0) : _jsx("div", Object.assign({
      className: "avatar-initials",
      style: {
        backgroundColor: getColorFromString(text)
      }
    }, {
      children: initials(text)
    }), void 0), showLabel && _jsxs("div", Object.assign({
      className: "avatar-label"
    }, {
      children: [_jsx("span", Object.assign({
        className: "avatar-text"
      }, {
        children: text
      }), void 0), subText && _jsx("span", Object.assign({
        className: "avatar-subtext"
      }, {
        children: subText
      }), void 0)]
    }), void 0)]
  }), void 0);
}

Avatar.Group = AvatarGroup;
export default Avatar;